import { NewsFeedRequestSerializer } from "../Dashboard/ProductDashboard/NewsFeed/NewsFeedSerializer";
import { fetchPutResponse } from "./ApiUtilities";

export const loadNews = async (
  chartData,
  setNewsList,
  setIsNewsLoading,
  setInUse,
  dateFilter,
  setDocumentIds,
  SetOffset,
  setNoMoreNews
) => {
  const offset = 0;
  const isin = chartData.map((x) => x.isin);
  if (isin.length === 0) {
    return;
  }
  const newsFeedRequest = new NewsFeedRequestSerializer({
    isin,
    offset,
    dateFilter,
  });
  SetOffset(0);
  setIsNewsLoading(true);
  setInUse(true);
  setNewsList([]);
  setNoMoreNews(false);

  try {
    const response = await fetchPutResponse("news/fetch_news", newsFeedRequest);
    const responseJson = await response.json();
    if (responseJson.data.length > 0) {
      SetOffset(offset + 100);
      setNewsList(responseJson.data);
    }
    const documentIds = responseJson.data.map((x) => {
      return { doc_id: x.id };
    });

    setDocumentIds(documentIds);
  } catch (error) {
    console.error(error);
  } finally {
    setInUse(false);
    setIsNewsLoading(false);
  }
};

export const loadMoreNews = async (
  offset,
  setInUseNews,
  setIsMoreNewsLoading,
  setNewsList,
  SetOffset,
  dateFilter,
  filterSelectedOptions,
  filterComapnies,
  setNoMoreNews,
  setDocumentIds
) => {
  if (offset !== 0) {
    setInUseNews(true);
    setIsMoreNewsLoading(true);

    const limit = 100;
    try {
      const requestBody = {
        locale: "en",
        for_id: filterSelectedOptions.selectedCompany
          ? filterSelectedOptions.selectedCompany.map((x) => x[1])
          : filterComapnies.current.map((x) => x[1]),
        start_date:
          dateFilter.startDate === "" ? new Date() : dateFilter.startDate,
        end_date: dateFilter.endDate === "" ? new Date() : dateFilter.endDate,
        limit,
        offset: offset,
      };
      const response = await fetchPutResponse("news/fetch_news", requestBody);
      const data = await response.json();
      if (data.data.length > 0) {
        const documentIds = data.data.map((x) => {
          return { doc_id: x.id };
        });
        setDocumentIds(documentIds);
        setNewsList((prevNewsList) => [...prevNewsList, ...data.data]);
        SetOffset(offset + limit);
      } else {
        setNoMoreNews(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsMoreNewsLoading(false);
      setInUseNews(false);
    }
  }
};

export const handleNewsClick = async (
  setSelectedNews,
  setNewsList,
  setInUse,
  news,
  document_ids,
  SetPrevDocumentIds,
  setDocumentIds
) => {
  try {
    setInUse(true);
    SetPrevDocumentIds(document_ids);
    setSelectedNews(news);
  } catch (error) {
    setNewsList("An error occurred. Please try again.");
    console.error(error);
  } finally {
    setInUse(false);
  }
};

export const loadNewsPointClick = async (
  isin,
  setNewsList,
  setIsNewsLoading,
  setInUse,
  startDate,
  setDocumentIds
) => {
  const locale = "en";
  let date = startDate === "" ? new Date() : new Date(startDate);
  let start_date = date.toISOString().split("T")[0];
  let endDate = startDate === "" ? new Date() : new Date(startDate);
  endDate.setDate(date.getDate() + 1);
  const end_date = endDate.toISOString().split("T")[0];
  const limit = 100;
  const offset = 0;

  const for_id = isin;
  setIsNewsLoading(true);
  setInUse(true);
  setNewsList([]);
  try {
    const requestBody = {
      locale,
      for_id,
      start_date,
      end_date,
      limit,
      offset,
    };
    const response = await fetchPutResponse("news/fetch_news", requestBody);

    const responseJson = await response.json();

    setNewsList(responseJson.data);
    const documentIds = responseJson.data.map((x) => {
      return { doc_id: x.id };
    });
    setDocumentIds(documentIds);
  } catch (error) {
    console.error(error);
  } finally {
    setInUse(false);
    setIsNewsLoading(false);
  }
};

export const getProcessedTextPreview = (text, maxLength) => {
  if (text === null || text === undefined || text === "")
    return "";
  if (text.length <= maxLength) {
    return text;
  }
  let trimmedText = text.substr(0, maxLength);
  trimmedText = trimmedText.substr(
    0,
    Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))
  );
  return `${trimmedText}...`;
};
